import React, { useState, useEffect } from 'react';

import axiosInstance from "../../../axiosInstance";
 import { Link } from 'react-router-dom';
 import Header from '../../components/Header';
 import Footer from '../../components/Footer';
 import AccountSidebar from '../../components/AccountSidebar';
 import getDecryptData from '../../../helper/getDecryptData';
import { Helmet } from 'react-helmet';
import LoadingScreen from '../../components/LoadingScreen';


const AccountAllVideoCall = () => {
  const [loading, setLoading] = useState(true);
  const [AllCall, setAllCall] = useState([]);

  const getUserAllVideo = async () => {
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;

    try {
      const response = await axiosInstance.get(`/admin/all-video-call?userId=${id}`);
      const { Order } = response?.data;
      setAllCall(Order || []);
      console.log('setAllCall', response.data);
    } catch (error) {
      console.error('Error fetching user calls:', error);
      setAllCall([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserAllVideo();
  }, []);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-IN', {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  };

  const getCallIcon = (status) => {
    if (status === 'missed') return <i className="call-icon text-danger bi bi-telephone-x-fill me-2" />;
    return <i className="call-icon text-success bi bi-telephone-fill me-2" />;
  };

  const getCallDuration = (start, end) => {
  const startTime = new Date(start);
  const endTime = end ? new Date(end) : new Date();

  const diffMs = endTime - startTime;
  if (diffMs <= 0) return '0s';

  const totalSec = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  parts.push(`${seconds}s`);

  return parts.join(' ');
};


  return (
    <>
       <Header title={'All Video Call'} searchtab={false}/>

      <Helmet>
        <title> Account Order | {window.location.hostname}</title>

      </Helmet>

     
        <div className="user-dasboard whitesmoke" >

          <div className="container pt-4">
            <div className="row pb-4">

              <AccountSidebar />

              <div className="col-lg-9 my-lg-0 my-1">
                <div id="main-content" className="bg-white border">
                     {loading ? (
            <LoadingScreen/>
          ) : AllCall.length === 0 ? (
            <>
          <h4 className="mb-4">Call History</h4>

   <div className="alert alert-warning">No calls found.</div>

            </>
          ) : (
            <>
                      <h3 className="mb-4">Call History</h3>
    <ul className="list-group">
              {AllCall.map((call, index) => {
                const user = call.sender?.username || 'Unknown';
                const email = call.receiver?.email || call.sender?.email || '';
                const callType = call.sender?._id === call.orderId?.userId ? 'Outgoing' : 'Incoming';
                const badgeColor = call.status === 'missed' ? 'danger' : 'success';
  const duration = getCallDuration(call.start, call.end);
  const isLive = !call.end;
                return (
                  <li
                    key={call._id}
                    className="list-group-item d-flex justify-content-between align-items-center call-item border-bottom"
                  >
                    <div className="d-flex align-items-center">
                      {getCallIcon(call.status)}
                      <div>
                        <h6 className="mb-0">{user}</h6>
                        <small className="text-muted">
                          {callType} • {formatTime(call.start)}
                        </small>
                        <br />
                       </div>
                    </div>
                    <div className="text-end">
                      <span className={`badge bg-${isLive ? 'warning' : badgeColor} d-inline-block mb-1`}>
                     {isLive ? 'Live' : call.status.charAt(0).toUpperCase() + call.status.slice(1) }   
                      </span>
                       
       {!isLive && <>
         <span className="d-block mb-1">   <i class="bi bi-clock-fill"></i>   {duration} </span> 
         </> }
    {isLive && 
     <Link
                        to={`/video-call?videoId=${call?._id}`}
                        className="btn btn-sm btn-outline-primary px-3 d-block py-1 small mt-2"
                      >
                        Join Now
                      </Link>
    }
                     
                    </div>
                  </li>
                );
              })}
            </ul>

</>
        
          )}

</div>
</div></div>
      </div>
      </div>  
 
<Footer/>
    
    </>

    
  );
};

export default AccountAllVideoCall;
